import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { getAppInsights } from "./TelemetryService";
import TelemetryProvider from "./telemetry-provider";
// import CustomSmartBanner from "./components/CustomComponents/CustomSmartBanner/CustomSmartBanner";
import CustomLoader from "./components/CustomLoader/CustomLoader";

let appInsights = null;
const loadingMarkup = <CustomLoader />
ReactDOM.render(
  <Suspense fallback={loadingMarkup}>
    {/* <React.StrictMode> */}
    <BrowserRouter>
      <TelemetryProvider
        instrumentationKey="INSTRUMENTATION_KEY"
        after={() => {
          appInsights = getAppInsights();
        }}
      >
        <App />
      </TelemetryProvider>
    </BrowserRouter>
    {/* </React.StrictMode> */}
  </Suspense>,
  document.getElementById("root")
);

// ReactDOM.render(
//   <CustomSmartBanner title={"Praiso App"} position="bottom" />,
//   document.getElementById("smartAppBanner")
// );

serviceWorker.unregister();
